import { apiFetch } from './client';

export const DELETION_REQUEST_ERRORS = {
  forbidden: 'You do not have permission to do this.',
  confirm_required: 'Confirmation is required to resolve this request.',
  customer_sub_required: 'This request is missing a customer reference.',
  cannot_delete_self: 'You cannot action a deletion request against your own account.',
  invalid_status: 'Choose either Approve or Reject.',
  not_found: 'This request could not be found — it may have already been resolved.',
  not_pending: 'This request has already been resolved — refresh to see its latest status.',
  cognito_error: 'Could not delete the account — try again.',
};

function normalizeDeletionRequest(raw) {
  return {
    sub: raw.customer_sub || raw.sub,
    username: raw.username,
    status: raw.status,
    reason: raw.reason || '',
    note: raw.note || '',
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  };
}

export async function listDeletionRequests(status = 'REQUESTED', token) {
  const raw = await apiFetch(`/admin/users/delete-requests?status=${encodeURIComponent(status)}`, { token });
  return (raw?.requests || []).map(normalizeDeletionRequest);
}

export function resolveDeletionRequest(sub, { status, note }, token) {
  return apiFetch(`/admin/users/delete-requests/${encodeURIComponent(sub)}/resolve`, {
    method: 'POST',
    token,
    body: {
      status,
      confirm: true,
      ...(note ? { note } : {}),
    },
  });
}
